import React from "react";
import LiveTvIcon from "../../../../icons/LiveTvIcon";
import { Button } from "../../../../shadcn/components/ui/button";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

export default function NoLiveAuctionEventComponent() {
  const router = useRouter();
  const portalAccessType = useSelector((state: any) => {
    return state.bidderAuth.portalAccessType;
  });
  const onlySwissEventUser = portalAccessType === "swiss";
  return (
    <div className="bg-white w-full min-h-[250px] flex justify-center items-center">
      <div className="flex flex-col justify-center items-center text-brand-textBlack font-sans">
        <LiveTvIcon height={58} width={58} color={"#FF752C"} />
        <div className="mt-2 font-normal">
          There are no live events for you to participate{" "}
        </div>
        {!onlySwissEventUser && (
          <div className="my-4 font-normal">
            Explore auctions you want to participate in
          </div>
        )}
        {!onlySwissEventUser && (
          <Button
            className="px-6"
            onClick={() => {
              router.push("/all-events");
            }}
          >
            All Events
          </Button>
        )}
      </div>
    </div>
  );
}
